import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

let itemChecked2 = [];
export default class AgregarUsuario extends Component {

    constructor(props) {
        super(props); 

        this.state = {
            categoriaLongitud:0,
            resource: {
				nFuenteOrigen: 4650,
                nUsuTipoAutenticacion: 884,//885: extero---------884:AD
                nUsuTipoUsuario: 886,//886:interno
                sUsuNombre: "",
                sUsuApellidoPaterno: "",
                sUsuApellidoMaterno: "",
                sUsuEmail: "",
                sUsuContrasenia: "",
                nUbiCodigo: 1350,
                sUsuDireccion: "",
                sUsuCadenaActivacion: "",
                sUsuTelefono: "",
                sUsuCelular: "",
                sectores: [
                    {
                    nTipSector: 1
                    }
                ],
                roles: [],
                activo: true,
                nUsuActivo: 1,
                nRolCodigo:0
            },
            Validacion: {
                sUsuNombre: {
                    Error: false,                    
                },
                sUsuApellidoPaterno: {
                    Error: false,                    
                },
                sUsuApellidoMaterno: {
                    Error: false,                    
                },
                sUsuEmail: {
                    Error: false,                    
                },
                sUsuContrasenia: {
                    Error: false,                    
                },
                nRolCodigo: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[],
            pagina:1,
            rolesAsignar:[],
            itemChecked2:[],
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

      onCheck = (id, event) => 
      {
          
          const target = event.target;
          itemChecked2 = [];
          itemChecked2[event.target.name] = !event.target.checked?false:true;
  
          let rolesAsignar = [];
  
          if(target.type === 'checkbox' )
          {
              if(event.target.checked){
                  rolesAsignar.push(id)
              }else{
                  let indice = rolesAsignar.indexOf(id);
  
                  if ( indice !== -1 ) {
                      rolesAsignar.splice( indice, 1 );
                  }
              }
          }
  
          setTimeout(() => {
              this.setState({itemChecked2, rolesAsignar: rolesAsignar});
          },100)
      }

    loadRoles = (page = 1) => {

        const url = `${API_URL}RolUX/listar/${page}/4650`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            $(".ipl-progress-indicator-head").css({"width": "100%"});
			setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
            }, 200);
            
            this.setState({ roles: data.result, pagina: 1});

            this.ShowPaginationFive(page-1);

            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });

    }

    /* PAGINACIÓN */
    executePaginationPrev(page, e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}

    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var entity = this.state.roles.length>0?this.state.roles[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
        $(".ipl-progress-indicator-head").css({"width": "90%"});
        
        this.loadRoles(page);
    }

    paginationTable()
    {
        var entity = this.state.roles.length > 0 ? this.state.roles[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages <= 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);
            
            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }
	
	ShowPaginationFive(pagina)
	{
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }
    /* FIN PAGINACIÓN */
    
    handleClickCancel(e) {
        const {history: {push}} = this.props;    
        push('/usuarios');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.sUsuNombre == '') {  
            
            newState.Validacion.sUsuNombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuApellidoPaterno == '') {  
            newState.Validacion.sUsuApellidoPaterno = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuApellidoMaterno == '') {  
            newState.Validacion.sUsuApellidoMaterno = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuEmail == '') {  
            newState.Validacion.sUsuEmail = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.sUsuContrasenia == '') {  
            newState.Validacion.sUsuContrasenia = {Error: true};
            newState.hasError = true;
        }

        if (this.state.rolesAsignar.length == 0) {  
            newState.Validacion.nRolCodigo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let nRolCodigo = this.state.rolesAsignar[0];

        const url = `${API_URL}UsuarioUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'nUsuCodCreacion', this.state.security.nUsuCodigo);
        dataForm = updateValueInJson(dataForm,'nRolCodigo', nRolCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.sUsuNombre = '';
                stateResponse.resource.sUsuApellidoPaterno = '';
                stateResponse.resource.sUsuApellidoMaterno = '';
                stateResponse.resource.sUsuEmail = '';
                stateResponse.resource.sUsuContrasenia = '';
                stateResponse.rolesAsignar = [];
                stateResponse.itemChecked2 = [];

                itemChecked2 = [];

                let resource = data.data.result;
                
                if(resource.nUsuCodigo > 0){
                    this.registrarRolUsuario(resource.nUsuCodigo, dataForm.nRolCodigo, resource.nUsuCodCreacion);
                }

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
            console.log(error);
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    registrarRolUsuario = (nUsuCodigo = 0, nRolCodigo = 0, nUsuCodCreacion = 0) => {

        let url = `${API_URL}UsuarioUX/RolUsuario`;
        var dataForm = {
            "nRolCodigo": nRolCodigo,
            "nUsuCodigo": nUsuCodigo,
            "nUsuCodCreacion": nUsuCodCreacion,
            "activo": true
          };

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                console.log("Rol registrado");
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        
        this.setState({loading:false});
        }); 
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });     
    }

    componentDidMount()
    {

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/usuarios";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 

        this.loadRoles();
    }

    render() {
        return (
            <div class="divRowContenedor_Panel">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/permisos">
                            / Usuarios
                        </Link>
                        <Link to="/usuarios">
                            / Lista de usuarios
                        </Link>
                        <span> / Agregar Usuario</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Usuario
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Nombres" name='sUsuNombre' 
                        value={this.state.resource.sUsuNombre} maxLength={255} 
                        className={this.state.Validacion.sUsuNombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>
                    
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Apellido Paterno" name='sUsuApellidoPaterno' 
                        value={this.state.resource.sUsuApellidoPaterno} maxLength={255} 
                        className={this.state.Validacion.sUsuApellidoPaterno.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Apellido Materno" name='sUsuApellidoMaterno' 
                        value={this.state.resource.sUsuApellidoMaterno} maxLength={255} 
                        className={this.state.Validacion.sUsuApellidoMaterno.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Correo Electrónico" name='sUsuEmail' 
                        value={this.state.resource.sUsuEmail} maxLength={255} 
                        className={this.state.Validacion.sUsuEmail.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Contraseña" name='sUsuContrasenia' 
                        value={this.state.resource.sUsuContrasenia} maxLength={20} 
                        className={this.state.Validacion.sUsuContrasenia.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtSelect-Radio">
                        <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Asignar rol:</b></p>
                        <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                            {
                                this.state.roles.length > 0 ?
                                this.state.roles.map((rol) => (
                                    <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                        <input type="checkbox" 
                                        style={{WebkitAppearance: 'checkbox'}} 
                                        name={"check_" + rol.nRolCodigo} 
                                        checked={this.state.itemChecked2["check_" + rol.nRolCodigo]}  
                                        onClick={(event) => this.onCheck(rol.nRolCodigo, event)}/>
                                        <label>{rol.sRolNombre}</label>
                                    </div> 
                                )) : null
                            }                           
                        </div>
                        {this.paginationTable()}
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo noneEvent"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}
